import sharingImg from '@/assets/images/share-fill.svg';
import volumeOffImg from '@/assets/images/volumeMute.svg';
import pauseImg from '@/assets/images/pause-fill.svg';
import closeButtonImg from '@/assets/images/closeButton.svg';

const MENU_ICON_SHADOW = 'drop-shadow(0 -1px .75px rgba(0, 0, 0, .38)) drop-shadow(0 0 .75px rgba(0, 0, 0, .42)) drop-shadow(0 1px .5px rgba(0, 0, 0, .18)) drop-shadow(0 2px 3px rgba(0, 0, 0, .2))';
const SAFARI_MENU_ICON_SHADOW = 'drop-shadow(0 0 1px rgb(0 0 0 / 0.60)) drop-shadow(1px 0 0 rgb(0 0 0 / 0.26)) drop-shadow(-1px 0 0 rgb(0 0 0 / 0.26)) drop-shadow(0 1px 0 rgb(0 0 0 / 0.22)) drop-shadow(0 -1px 0 rgb(0 0 0 / 0.22)) drop-shadow(0 2px 4px rgb(0 0 0 / 0.20))';

const isSafari = () => {
  const userAgent = window.navigator.userAgent;
  return /Safari/.test(userAgent) && !/(Chrome|Chromium|CriOS|FxiOS|Edg|OPR|Android)/.test(userAgent);
};

const applyMenuIconShadow = (icon) => {
  // Safariでfilterの上側が切れないよう透明余白を確保し、影は各アイコンへ付与する
  const shadow = isSafari() ? SAFARI_MENU_ICON_SHADOW : MENU_ICON_SHADOW;
  icon.style.boxSizing = 'content-box';
  icon.style.padding = '2px';
  icon.style.margin = '-2px';
  icon.style.filter = shadow;
  icon.style.webkitFilter = shadow;
};

export const mobileMenuArea = () => {
  // アイコンコンテナの作成 - flexboxを使用して縦並びに
  const iconsDiv = document.createElement('div');
  iconsDiv.className = 'storeeel-menu-area-icons';
  iconsDiv.style.display = 'flex';
  iconsDiv.style.flexFlow = 'column';
  iconsDiv.style.alignItems = 'center';
  iconsDiv.style.justifyContent = 'flex-end'; // 右寄せにする
  iconsDiv.style.padding = '15px 16px';
  iconsDiv.style.gap = '21px'; // 要素間の間隔
  iconsDiv.style.position = 'fixed';
  iconsDiv.style.top = '0';
  iconsDiv.style.right = '0';
  iconsDiv.style.zIndex = '11000';
  iconsDiv.style.paddingTop = '55px';

  // 音量オフアイコンの作成
  const volumeIcon = document.createElement('img');
  volumeIcon.src = volumeOffImg;
  volumeIcon.alt = 'volume';
  volumeIcon.style.width = '24px';
  volumeIcon.style.height = '24px';
  volumeIcon.style.aspectRatio = '1 / 1';
  volumeIcon.style.cursor = 'pointer';
  volumeIcon.setAttribute('data-muted', 'true'); // 初期状態はミュート
  applyMenuIconShadow(volumeIcon);

  // 共有アイコンの作成
  const sharingIcon = document.createElement('img');
  sharingIcon.src = sharingImg;
  sharingIcon.alt = 'sharing';
  sharingIcon.style.width = '24px';
  sharingIcon.style.height = '24px';
  sharingIcon.style.aspectRatio = '1 / 1';
  sharingIcon.style.height = 'auto';
  applyMenuIconShadow(sharingIcon);

  // 閉じるボタンの作成
  const closeButton = document.createElement('img');
  closeButton.src = closeButtonImg;
  closeButton.className = 'cross-close-button-parent';
  closeButton.style.display = 'inline-block';
  closeButton.style.verticalAlign = 'middle';
  closeButton.style.position = 'relative'; // position: relativeに変更
  closeButton.style.marginTop= '-8px';
  closeButton.style.width = '24px';
  closeButton.style.height = '24px';
  closeButton.style.aspectRatio = '1 / 1';
  applyMenuIconShadow(closeButton);

  // 2025-05-04一時停止ボタンの作成
  const pauseButton = document.createElement('img');
  pauseButton.src = pauseImg;
  pauseButton.alt = 'pause';
  pauseButton.style.width = '24px';
  pauseButton.style.height = '24px';
  pauseButton.style.aspectRatio = '1 / 1';
  pauseButton.className = 'storeeel-video-control';
  pauseButton.id = 'pause-desktop';
  pauseButton.style.cursor = 'pointer';
  applyMenuIconShadow(pauseButton);

  // アイコンをアイコンコンテナに追加 (順番を変更して右から「閉じる」「共有」「音量」の順に)
  iconsDiv.appendChild(closeButton);
  iconsDiv.appendChild(volumeIcon);
  // 2025-05-04一時停止ボタンの生成
  iconsDiv.appendChild(pauseButton);
  iconsDiv.appendChild(sharingIcon);

  const htmlString = `
    ${iconsDiv.outerHTML}
  `;

  return htmlString;
}
